
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic03On as ObiHydraulic03OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-03-on.js';
 
 
 

 
 export const ObiHydraulic03On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-03-on',
   elementClass: ObiHydraulic03OnElement,
   events: {
     
   }
  });
 
 